import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Datafield } from 'src/app/models/database/datafield.model';
import { DatasheetBuilderService } from 'src/app/services/datasheet-builder/datasheet-builder.service';
import { DatafieldAttributes, DatasheetService } from 'src/app/services/datasheet/datasheet.service';
import { DatafieldsEnum } from '../datafield.enum';
import { IDatafieldComponent } from '../datafield.interface';

@Component({
  selector: 'app-datafield-text',
  templateUrl: './datafield-text.component.html',
  styleUrls: ['./datafield-text.component.scss']
})
export class DatafieldTextComponent implements OnInit, OnDestroy, IDatafieldComponent {

  label: string
  session: string
  value: any
  datafield: Datafield
  subscriptionManager: Subscription = new Subscription()
  textInputFormControl: FormControl = this.formBuilder.control('', [Validators.required])
  formGroupSubmitted: boolean = false

  constructor(
    private formBuilder: FormBuilder,
    private datasheetService: DatasheetService,
    public datasheetBuilderService: DatasheetBuilderService
  ) { }

  ngOnInit(): void {
    if (this.value) {
      this.textInputFormControl.setValue(this.value)
      this.textInputFormControl.disable()
    }
    this.subscriptionManager.add(this.datasheetService.datafieldValidationSubject
      .pipe(tap(() => {
        this.formGroupSubmitted = true
        if (this.textInputFormControl.invalid) {
          this.datasheetService.everythingIsValid = false
          return
        }
        this.formGroupSubmitted = false
      })).subscribe())
    this.subscriptionManager.add(this.datasheetService.datasheetObjectBuilder$.pipe(
      tap(() => {
        const datafieldAttributes: DatafieldAttributes =
          new DatafieldAttributes(DatafieldsEnum.TEXT, this.label, this.textInputFormControl.value)
        this.datasheetService.buildDatasheetObject(this.session, datafieldAttributes)
      })
    ).subscribe())
  }

  ngOnDestroy(): void {
    this.subscriptionManager.unsubscribe()
  }
}
